// extracted by mini-css-extract-plugin
module.exports = {"html":"e_tx"};